<template>
  <template v-for="t in transactions" :key="t.$id">
    <tr>
      <td>{{ t.total }}</td>
      <td>{{ t.initiated ? new Date(t.initiated).toLocaleString() : "Unknown" }}</td>
      <td>{{ t.initiated ? estimatedDate(t.initiated) : "Unknown" }}</td>
      <td v-if="!t.voided"><button class="secondary" :disabled="t.voided || loading" :class="{refunded: t.voided}" @click="refundTransaction(t)">Refund</button></td>
      <td v-if="t.voided" class="refunded"><div>Refunded</div></td>
      <td><button class="secondary" :disabled="loading" @click="openStripeLink(t)">Open in Stripe</button></td>
    </tr>
  </template>
</template>

<script setup lang="ts">
import type { Transaction } from '@busy-human/payment-module';
import type { DataInstance } from '@busy-human/gearbox';
import { ref, watch } from 'vue';
import { firestore } from '../util/firebase';
import { type CollectionReference, collection, getDocs, query, where } from 'firebase/firestore';
import { stripeIssueRefund } from '@/util/functions';

const props = defineProps<{stripeIds: string[]}>();
const loading = ref(false);

const transactions = ref<DataInstance<Transaction.Model>[]>([]);
async function fetchTransactions() {
	if(!props.stripeIds.length) return;
	loading.value = true;
	// TODO: Move this logic to gearbox
	try{

		const col = collection(firestore, "Transactions") as CollectionReference<Transaction.Model>;
		const q = query(col, where("externalIds.stripe", "in", props.stripeIds));
		const docs = await getDocs(q);
		transactions.value = docs.docs.map(d => ({
			... d.data(),
			$id: d.id
		}));
	
	}catch(e){
		console.log("Error", e);
	}
	
	
	loading.value = false;
}

async function refundTransaction(transaction: DataInstance<Transaction.Model>) {
	if(!transaction.externalIds.stripe) return;
	if(transaction.voided) return;
	loading.value = true;
	try {
		await stripeIssueRefund({transactionId: transaction.$id});
		console.log(transaction.externalIds.stripe);
		// TODO: Do something else
		alert("Refunded");
	} catch (e) {
		// TODO: Do something else
		alert((e as Error).message);
	} finally {
		await fetchTransactions();
	}
}

function openStripeLink(transaction: DataInstance<Transaction.Model>) {
	if (process.env.NODE_ENV === 'development') {
		const link = `https://dashboard.stripe.com/test/payments/${transaction.externalIds.stripe}`;
		window.open(link);
	} else {
		const link = `https://dashboard.stripe.com/payments/${transaction.externalIds.stripe}`;
		window.open(link);
	}
}

function estimatedDate(date: string | Date) {
	const tmp = new Date(date);
	const followingDate = new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate() + 2, tmp.getHours(), tmp.getMinutes());
	return followingDate.toLocaleDateString();
}

watch(() => props.stripeIds, async () => {
	await fetchTransactions();
}, {immediate: true, deep: true});

</script>

<style lang="scss">
.refunded {
	color: #a70024;
}
</style>